import * as React from 'react';
import getDensityOptionState from '../store/store';
import DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import DensityOptionState from '../store/schema/DensityOptionState';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getFallbackValueIfNull } from 'owa-options-core';
import { observer } from 'mobx-react';
import { displayDensityOptionSelected } from '../actions/internalActions';
import strings from 'owa-strings/owa-options-strings';

export interface DensityFullProps {
    optionState?: DensityOptionState;
}

@observer
export default class DisplayDensityFull extends React.Component<DensityFullProps, {}> {
    render() {
        const optionState = getDensityOptionState();
        const densityModeSelected = getFallbackValueIfNull(
            optionState.densityModeSelected,
            getUserConfiguration().UserOptions.DisplayDensityMode
        );

        const options = [
            {
                key: 'Full',
                text: strings.options_density_modeFull,
            },
            {
                //The server stores density mode string as 'Simple' instead of 'Medium'
                // so keeping the key as Simple here
                key: 'Simple',
                text: strings.options_density_modeMedium,
            },
            {
                key: 'Compact',
                text: strings.options_density_modeCompact,
            },
        ];

        return (
            <ChoiceGroup
                selectedKey={`${densityModeSelected}`}
                label={strings.options_messageHeight_positionLabel}
                options={options}
                onChange={this.onChange}
            />
        );
    }

    private onChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        displayDensityOptionSelected(option.key as DisplayDensityMode);
    };
}
